var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"header"}},[_c('img',{staticClass:"guy",attrs:{"src":_vm.getGuy}}),_c('img',{staticClass:"erdinand-logo",attrs:{"src":_vm.getLogo}}),_c('div',{staticClass:"subline"},[_vm._v("bringt's in den Garten ohne Stress.")])])}
var staticRenderFns = []

export { render, staticRenderFns }